import React, { memo, useEffect, useState } from 'react';
import { ProductSearchForm } from './ProductSearchForm';
import { ParamsProvider } from './contexts/ParamsProvider';
import * as s from "./ProductSearch.module.scss"

import type { ReactElement } from 'react';
import type { IParams } from './types';
import useWindowSize from '../../../hook/useWindowSize';

export { IParams };

interface IProps {
  onChange: (params: IParams) => void | Promise<void>;
}

export const ProductSearch: VFC<IProps> = memo((): ReactElement => {
  const [windowWidth] = useWindowSize()
  const [showAccordion, setShowAccordion] = useState(false)
  useEffect(() => {
    setShowAccordion(windowWidth >= 768)
  }, [windowWidth])
  return (
    <details className={s.accordion} open={showAccordion} onToggle={(e) => {
      setShowAccordion(e.target.open)
    }}>
      <summary className="border">詳細検索</summary>
      <ProductSearchForm />
    </details>
  );
});
